import { LegacyTypesPermissions } from "@components/Routes/legacyTypesPermissions";
import { UserType } from "@utils/enum";

export function legacyCheckOnlyDriverPermission(
  systemModules: string[],
  roles: string[]
): boolean {
  const checkPermissionPortalCliente = roles.some(
    (role) => role === LegacyTypesPermissions.PORTAL_CLIENTE
  );
  const checkHasOnlyDriverModule =
    systemModules.length === 1 &&
    systemModules.some(
      (module) => module === LegacyTypesPermissions.DRIVER.replace(":*", "")
    );

  return checkPermissionPortalCliente && checkHasOnlyDriverModule;
}

export function legacyCheckDriverOrContactPermission(
  systemModules: string[],
  roles: string[]
): boolean {
  const checkPermissionPortalCliente = roles.some(
    (role) => role === LegacyTypesPermissions.PORTAL_CLIENTE
  );

  const checkHasOnlyDriverModule = legacyCheckOnlyDriverPermission(
    systemModules,
    roles
  );

  const checkHasOnlyCostumerModule =
    systemModules.length > 0 &&
    systemModules.some(
      (module) => module === LegacyTypesPermissions.CONTACT.replace(":*", "")
    );

  const checkDriverOrCustomer =
    checkHasOnlyDriverModule || checkHasOnlyCostumerModule;

  return checkPermissionPortalCliente && checkDriverOrCustomer;
}

export function legacyCheckCarrierPermission(
  systemModules: string[],
  roles: string[]
): boolean {
  const checkPermissionPortalCliente = roles.some(
    (role) => role === LegacyTypesPermissions.PORTAL_CLIENTE
  );

  const checkHasCarrierModule =
    systemModules.length > 0 &&
    systemModules.some(
      (module) => module === LegacyTypesPermissions.CARRIER.replace(":*", "")
    );
  return checkPermissionPortalCliente && checkHasCarrierModule;
}

export function legacyCheckCIFDriverPermission(roles: string[]): boolean {
  return [
    LegacyTypesPermissions.CIF_DRIVER,
    LegacyTypesPermissions.PORTAL_CLIENTE,
  ].every((role) => roles.includes(role));
}

export const legacyGetUserType = (
  systemModules: string[],
  roles: string[]
): UserType => {
  switch (true) {
    case legacyCheckCarrierPermission(systemModules, roles):
      return UserType.Transportadora;
    case legacyCheckOnlyDriverPermission(systemModules, roles):
      return UserType.Motorista;
    default:
      return UserType.Cliente;
  }
};

export function isLegacyProfileOnlyDriver(systemModules: string[]): boolean {
  return (
    systemModules.includes("portal_cliente:driver") &&
    systemModules.length === 1
  );
}
